module.exports = ".metadata-item{margin-bottom:1em}";